import { useState } from 'react';
import { api, extractErrorMessage } from '../../api/client';
import { Button } from '../../components/Button';
import { Confirm } from '../../components/Confirm';

/** POST mantenimiento/datos-prueba. */
interface ResumenCarga { yaCargados: boolean; proveedores: number; skus: number; articulos: number; ordenes: number }
/** DELETE mantenimiento/datos-prueba. */
interface ResumenBorrado {
  proveedores: number; skus: number; articulos: number; ordenes: number; remitos: number; recepciones: number;
  movimientos: number; filasStock: number;
}

const URL = '/api/v3/mantenimiento/datos-prueba';

/** "a, b y c" */
const enumerar = (partes: string[]) => (partes.length > 1 ? `${partes.slice(0, -1).join(', ')} y ${partes[partes.length - 1]}` : partes[0] ?? '');
const comunes = (r: { proveedores: number; skus: number; articulos: number; ordenes: number }) =>
  [`${r.proveedores} proveedores`, `${r.skus} SKU`, `${r.articulos} artículos de proveedor`, `${r.ordenes} OC`];

const MENSAJE_CARGAR = 'Se crean dos proveedores ("PRUEBA Carti" y "PRUEBA Proveedor B"), SKU de prueba con código PRUEBA-… '
  + 'y las OC PRUEBA-OC-001 a PRUEBA-OC-006, listas para recibir. Cada OC dice en sus notas qué hay que probar.'
  + '\nNo se toca ningún producto real ni Mercado Libre. Si ya están cargados, no se crea nada.';
const MENSAJE_BORRAR = 'Se borran los proveedores, SKU y OC de PRUEBA, y todo lo que cuelga de ellos: remitos, recepciones del depósito, '
  + 'movimientos y stock de los SKU de prueba.'
  + '\nSi algo mezcla datos reales (por ejemplo, un remito de PRUEBA con un producto real), no se borra nada y se avisa qué es.'
  + '\nNo se puede deshacer.';

/**
 * Configuración → Mantenimiento → "Datos de PRUEBA" (la página la muestra sólo a admin): carga y borra los datos de la
 * demo de remitos en el sistema real. Todo lleva la palabra PRUEBA; el backend los identifica por esa marca.
 */
export function DatosPrueba() {
  const [accion, setAccion] = useState<'cargar' | 'borrar' | null>(null);
  const [procesando, setProcesando] = useState(false);
  const [resultado, setResultado] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const ejecutar = async () => {
    const que = accion;
    setAccion(null);
    setProcesando(true); setResultado(null); setError(null);
    try {
      if (que === 'cargar') {
        const r = await api.post<ResumenCarga>(URL, {});
        setResultado(r.yaCargados ? 'Los datos de PRUEBA ya estaban cargados: no se creó nada.' : `Se cargaron ${enumerar(comunes(r))}.`);
      } else {
        const r = await api.delete<ResumenBorrado>(URL);
        setResultado(`Se borraron ${enumerar([...comunes(r), `${r.remitos} remitos`, `${r.recepciones} recepciones del depósito`,
          `${r.movimientos} movimientos de stock`, `${r.filasStock} filas de stock`])}.`);
      }
    } catch (e) {
      setError(extractErrorMessage(e));
    } finally {
      setProcesando(false);
    }
  };

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-3">
        <Button onClick={() => setAccion('cargar')} disabled={procesando}>Cargar datos de PRUEBA</Button>
        <Button variant="danger" onClick={() => setAccion('borrar')} disabled={procesando}>Borrar datos de PRUEBA</Button>
      </div>
      {resultado && <p role="status" className="text-sm text-green-700 bg-green-50 border border-green-200 rounded-lg px-3 py-2">{resultado}</p>}
      {error && <p role="alert" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</p>}
      <Confirm
        open={accion === 'cargar'}
        title="Cargar datos de PRUEBA"
        message={MENSAJE_CARGAR}
        confirmLabel="Cargar"
        onConfirm={() => { void ejecutar(); }}
        onCancel={() => setAccion(null)}
      />
      <Confirm
        open={accion === 'borrar'}
        title="Borrar datos de PRUEBA"
        message={MENSAJE_BORRAR}
        confirmLabel="Borrar"
        danger
        onConfirm={() => { void ejecutar(); }}
        onCancel={() => setAccion(null)}
      />
    </div>
  );
}
